import Vue from 'vue'
import VueRouter from 'vue-router'
import Router from 'vue-router'
import Login from '../components/views/Profile/Login'
import store from '../store'
Vue.use(VueRouter)


const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/profile',
      meta: {}
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      props: { ActivePage: 'forgotpassword' },
      component: Login,
      meta: { listed: false }
    },
    {
      path: '/resetpassword',
      name: 'NewPassword',
      props: { ActivePage: 'resetPassword' },
      component: Login,
      meta: { listed: false }
    },
    {
      path: '/register',
      name: 'Register',
      props: { ActivePage: 'register' },
      component: Login,
      meta: { listed: false }
    },
    {
      path: '/login',
      name: 'Login',
      props: { ActivePage: 'login' },
      component: Login,
      meta: { listed: false }
    },
    {
      path: '/verify-login',
      name: 'LoginVerification',
      props: { ActivePage: 'loginVerify' },
      component: Login,
      meta: { listed: false }
    },
    {
      path: '/authorize',
      name: 'Authorize',
      component: () => import('../components/views/Profile/Authorize.vue'),
      meta: { listed: false }
    },
    {
      path: '/profile',
      name: 'Profile',
      component: () => import('../components/views/Profile/Profile.vue'),
      meta: { icon: 'mdi-account', listed: true, bcText: 'Profile' },
      redirect: '/profile/emails',
      children: [
        {
          path: 'emails',
          name: 'Emails',
          component: () => import('../components/views/Profile/Emails.vue'),
          meta: { icon: 'mdi-account', listed: false, bcText: 'Emails' }
        },
        {
          path: 'phonenumbers',
          name: 'PhoneNumbers',
          component: () => import('../components/views/Profile/PhoneNumbers.vue'),
          meta: { listed: false, bcText: 'Phone numbers' }
        },
        {
          path: 'privacy',
          name: 'DataAndPrivacy',
          component: () => import('../components/views/Profile/DataAndPrivacy.vue'),
          meta: { listed: false, bcText: 'Profile Settings' }
        }
      ]
    },
    {
      path: '/profile/emails/add',
      name: 'AddEmail',
      component: () => import('../components/views/Profile/AddEmail.vue'),
      meta: { listed: false, bcText: 'Add new' }
    },
    {
      path: '/profile/emails/:label/verify',
      name: 'VerifyEmail',
      component: () => import('../components/views/Profile/AddEmail.vue'),
      meta: { listed: false, bcText: 'Verify' }
    },
    {
      path: '/profile/phonepumbers/add',
      name: 'AddPhoneNumber',
      component: () => import('../components/views/Profile/AddPhoneNumber.vue'),
      meta: { listed: false, bcText: 'Add new' }
    },{
      path: '/profile/phonenumbers/:label/verify',
      name: 'VerifyPhoneNumber',
      component: () => import('../components/views/Profile/AddPhoneNumber.vue'),
      meta: { listed: false, bcText: 'Verify' }
    },
    {
      path: '/profile/password/change',
      name: 'PasswordChange',
      component: () => import('../components/views/Profile/PasswordChange.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Change password' }
    },
    {
      path: '/profile/username/change',
      name: 'UsernameChange',
      component: () => import('../components/views/Profile/UsernameChange.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Change username' }
    },
    {
      path: '/organizations',
      name: 'Organizations',
      component: () => import('../components/views/Organizations/Organizations.vue'),
      meta: { icon: 'mdi-account-group', listed: true, bcText: 'Organizations' }
    },
    {
      path: '/organizations/add',
      name: 'AddOrganization',
      component: () => import('../components/views/Organizations/AddOrganization.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Create organization' }
    },
    {
      path: '/organizations/:organization/',
      name: 'OrganizationManagement',
      component: () => import('../components/views/Organizations/OrganizationManagement.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Organizations' },
      redirect: '/organizations/:organization/people',
      children: [
        {
          path: '/organizations/:organization/people',
          name: 'OrganizationPeople',
          component: () => import('../components/views/Organizations/People.vue'),
          meta: { listed: false, bcText: 'People' }
        },
        {
          path: '/organizations/:organization/organizations',
          name: 'OrganizationOrganizations',
          component: () => import('../components/views/Organizations/OrgOrganizations.vue'),
          meta: { listed: false, bcText: 'Organizations' }
        },
        {
          path: '/organizations/:organization/structure',
          name: 'OrganizationStructure',
          component: () => import('../components/views/Organizations/Structure.vue'),
          meta: { listed: false, bcText: 'Structure' }
        },
        {
          path: '/organizations/:organization/api-access-keys',
          name: 'OrganizationApiAccessKeys',
          component: () => import('../components/views/Organizations/ApiAccessKeys.vue'),
          meta: { listed: false, bcText: 'API access keys' }
        },
        {
          path: '/organizations/:organization/settings',
          name: 'OrganizationSettings',
          component: () => import('../components/views/Organizations/OrganizationSettings.vue'),
          meta: { listed: false, bcText: 'Settings' }
        }
      ]
    },
    {
      path: '/organizations/:organization/api-access-keys/add',
      name: 'OrganizationAddAPIKey',
      component: () => import('../components/views/Organizations/AddKey.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Add new' }
    },
    {
      path: '/organizations/:organization/api-access-keys/:label/edit',
      name: 'OrganizationEditAPIKey',
      component: () => import('../components/views/Organizations/AddKey.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Edit' }
    },
    {
      path: '/organizations/:organization/organizations/invite',
      name: 'InviteOrg',
      component: () => import('../components/views/Organizations/InviteOrg.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Invite organization' }
    },
    {
      path: '/organizations/:organization/people/invite',
      name: 'InviteUser',
      component: () => import('../components/views/Organizations/InviteUser.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Invite user' }
    },
    {
      path: '/organizations/:organization/organizations/add',
      name: 'AddSubOrganization',
      component: () => import('../components/views/Organizations/AddSubOrg.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Add sub organization' }
    },
    {
      path: '/settings',
      name: 'Settings',
      component: () => import('../components/views/Settings/Settings.vue'),
      meta: { icon: 'mdi-cog', listed: true, bcText: 'Settings' },
      redirect: '/settings/access-tokens',
      children: [
        {
          path: 'access-tokens',
          name: 'AccessTokens',
          component: () => import('../components/views/Settings/AccessTokens.vue'),
          meta: { icon: 'mdi-account', listed: false, bcText: 'Access tokens' }
        },
        {
          path: 'ssh-keys',
          name: 'SshKeys',
          component: () => import('../components/views/Settings/SshKeys.vue'),
          meta: { icon: 'mdi-account', listed: false, bcText: 'SSH keys' }
        },
        {
          path: 'authenticator',
          name: 'Authenticator',
          component: () => import('../components/views/Settings/Authenticator.vue'),
          meta: { icon: 'mdi-account', listed: false, bcText: 'Authenticator' }
        }
      ]
    },
    {
      path: '/settings/ssh-keys/add',
      name: 'AddSshKey',
      component: () => import('../components/views/Settings/AddSshKey.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Add new' }
    },
    {
      path: '/settings/ssh-keys/:publicKey',
      name: 'EditSshKey',
      component: () => import('../components/views/Settings/AddSshKey.vue'),
      meta: { listed: false, bcText: 'Edit' }
    },
    {
      path: '/settings/access-tokens/add',
      name: 'AddAccessToken',
      component: () => import('../components/views/Settings/AddAccessToken.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Add new' }
    },
    {
      path: '/settings/access-tokens/:ApiKey',
      name: 'EditAccessToken',
      component: () => import('../components/views/Settings/AddAccessToken.vue'),
      meta: { icon: 'mdi-account', listed: false, bcText: 'Edit' }
    },
    {
      path: '/:globalId/info-shared',
      name: 'InfoShared',
      component: () => import('../components/views/SharedInfo/InfoShared.vue'),
      meta: { icon: 'mdi-repeat-variant', listed: false, bcText: 'Information shared' }
    },
    {
      path: '/shared-info',
      name: 'SharedInfo',
      component: () => import('../components/views/SharedInfo/SharedInfo.vue'),
      meta: { icon: 'mdi-repeat-variant', listed: true, bcText: 'Shared information' }
    },
    {
      path: '/notifications',
      name: 'Notifications',
      component: () => import('../components/views/Notifications/Notifications.vue'),
      meta: { icon: 'mdi-flag', listed: false, bcText: 'Notifications' }
    }
  ]

})
router.beforeResolve( (to, from, next) => {
  if (store.state.user == "" && to.path == '/profile/emails') {
    next({ name: 'Login' })
  } else next()
})

export default router


